<template>
    <div class="wrapper">
        <b-table class="table" sticky-header striped hover small table-variant="secondary" :items="dcxUnregistered" :fields="unregisteredFields" :tbody-tr-class="rowClass">
            <template v-slot:cell(Details)="row">
                <b-button size="sm" @click="row.toggleDetails" class="mr-2 detailsBtn">
                    {{ row.detailsShowing ? $t('Hide') : $t('Details') }}
                </b-button>
            </template>
            <template v-slot:row-details="row">
                <b-card>
                    <ul class="detailsList">
                        <li v-for="(value, name) in row.item.DetailledData">
                            <div class="detailsRow"><span class="detailName">{{name}} :</span> {{ value }}</div>
                        </li>
                    </ul>
                </b-card>
            </template>
        </b-table>
        <b-list-group class="legendList" horizontal>
            <b-list-group-item class="legendItem" flex-fill>
                <font-awesome-icon :icon="['fa', 'square']" size="sm" class="iconOK" /> {{ $t('InvariantNotFound') }} <!-- Invariant introuvable -->
            </b-list-group-item>
            <b-list-group-item class="legendItem" flex-fill>
                <font-awesome-icon :icon="['fa', 'square']" size="sm" class="iconKO" /> {{ $t('InvariantNonExistent') }} <!-- Invariant inexistant -->
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import map from '@/types/map/type-map';
    import { State, namespace } from 'vuex-class';

    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faSquare } from "@fortawesome/free-solid-svg-icons";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

    import * as esriLoader from 'esri-loader';

    library.add(faSquare);

    const CartoModule = namespace("CartoMod");

    @Component({
        name: 'arcgis-unregistered-dcx',
        components: {
            FontAwesomeIcon
        }
    })

    export default class ArcgisUnregisteredDcx extends Vue {

        @CartoModule.State
        private arcgisFeatures!: object[];
        @CartoModule.State
        private arcgisUnregistered!: any[];
        @CartoModule.State
        private map!: map;
        @CartoModule.State
        private dcxUnregistered!: object[];
        @CartoModule.State
        private isLoadingUnregistered!: boolean;
        @CartoModule.Mutation
        private setArcgisData!: (Invariants: object[]) => void;
        @CartoModule.Mutation
        private setDcxUnregistered!: (Invariants: object[]) => void;
        @CartoModule.Mutation
        private setIsLoadingUnregistered!: (booleanSetter: boolean) => void;

        @Watch('arcgisFeatures')
        getUnregisteredArcgis() {
            //if (this.isLoadingUnregistered == false) {
            if (this.arcgisFeatures.length > 0) {
                this.setIsLoadingUnregistered(true);
                this.$Direct.postAwaitable("carto/getUnregisteredArcgis", this.arcgisFeatures).then((result) => {
                    this.setDcxUnregistered(result);
                    for (let unregisteredFeature of result) {
                        this.sendItemQuery(unregisteredFeature.ObjectId).then((result) => {
                            unregisteredFeature.DetailledData = result;
                        })
                    }
                    //this.setIsLoadingUnregistered(false);
                })
            //}
            }
        }

        private unregisteredFields: string[] = ['Invariant', 'ContractName', 'Details'];

        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.Invariant === 'None') return 'table-danger'
        }

        async sendItemQuery(objectId: string) {

            var itemDetails;
            await esriLoader.loadModules([
                'esri/tasks/QueryTask',
                'esri/tasks/support/Query'
            ])
                .then(async ([
                    QueryTask,
                    Query
                ]) => {
                    const queryTask = new QueryTask({
                        url: "https://sig.grandpoitiers.fr/arcgis2/rest/services/DICT/DELTA_CONSO/MapServer/1"
                    })
                    const query = new Query();
                    query.where = "OBJECTID =" + objectId
                    query.outFields = ["*"]
                    await queryTask.execute(query).then((results) => {
                        itemDetails = results.features[0].attributes
                    })
                })
            return itemDetails
        }
    }
</script>

<style scoped>
    .wrapper {
        background-color: white;
    }

    .table {
        width: 450px;
    }

    .legendItem {
        border-radius: 0 !important;
        width: 50%;
    }

    .iconKO {
        color: #F5C6CB;
        overflow: hidden;
        border: 1px solid black;
    }

    .iconOK {
        color: white;
        overflow: hidden;
        border: 1px solid black;
    }

    .detailName {
        font-weight: bold;
    }

    .detailsList {
        list-style: none;
    }

    .detailsBtn:hover {
        transform : scale(1) !important ;
    }
</style>